import { simpleFetch } from '@api/fetchers';
import { getHost } from '@utils/api-helper/host';
import {
  PrimeTrialPromoApiResponse,
  PrimeTrialPromoContextualId
} from './types';

const getAuthOptions = (accessToken: string) => ({
  authorization: accessToken
});

const host = getHost();

export default function fetchPrimeTrialPromoDetails({
  goalUID,
  contextualFlow,
  accessToken
}: {
  goalUID: string;
  contextualFlow: PrimeTrialPromoContextualId;
  accessToken: string;
}): Promise<PrimeTrialPromoApiResponse> {
  if (!accessToken) {
    return Promise.reject(new Error('Access token is required'));
  }

  return simpleFetch(
    `${host}v1/library/landing-page/?goal_uid=${goalUID}&contextual_flow=${contextualFlow}`,
    {
      ...getAuthOptions(accessToken)
    }
  );
}
